import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import {
    getBannerModerationThemeLink,
    getBannerModerationThemeTitle
} from '../../../service/Moderation/Moderation';
import { LinkTarget } from '../../../typings/common';
import { BannerModerationTheme } from '../../../typings/domain';
import {
    RecommendationCharacter,
    RecommendationType
} from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import {
    RecommendationCard,
    RecommendationCardView
} from '../RecommendationCard';

import * as keyset from './SendLisencesRecommendationCard.i18n';

const i18n = i18nFactory(keyset);

export interface SendLisencesRecommendationCardProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view:
        | RecommendationCardView.normal
        | RecommendationCardView.recommendationsPopup;
    theme: BannerModerationTheme;
    onSendLicenseButtonClick?: () => void;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export class SendLisencesRecommendationCard extends React.PureComponent<
    SendLisencesRecommendationCardProps
> {
    render() {
        const { view, character, icon, onShow, theme } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.sendLicenses}
                view={view}
                icon={icon}
                character={character}
                title={i18n('title', {
                    theme: getBannerModerationThemeTitle(theme)
                })}
                titleHint={this.getTitleHint()}
                buttons={this.getButtons()}
                isInProgress={false}
                onShow={onShow}
            >
                {i18n('description-text')}
            </RecommendationCard>
        );
    }

    private getTitleHint = (): string => {
        const { view } = this.props;

        switch (view) {
            case RecommendationCardView.normal:
                return i18n('several-banners-title-hint');

            case RecommendationCardView.recommendationsPopup:
                return i18n('one-banner-title-hint');

            default:
                throw Error(
                    `Не определена подпись для заголовка рекомендации вида ${view}`
                );
        }
    };

    private getButtons = () => {
        const { theme, onSendLicenseButtonClick } = this.props;

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                text={i18n('send-lisence-letter')}
                type={'link'}
                target={LinkTarget.blank}
                onClick={onSendLicenseButtonClick}
                url={getBannerModerationThemeLink(theme)}
            />
        ];
    };
}
